import React from 'react'
import { AppBar, Toolbar, Typography, Box } from '@mui/material'
import LogoExample from './LogoExample'

const Topbar: React.FC = () => {
  return (
    null
    // <AppBar position="static" sx={{ backgroundColor: '#1976d2' }}>
    //   <Toolbar>
    //     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    //       <LogoExample />
    //       <Typography variant="h6" sx={{ fontWeight: 700 }}>
    //         MyAssets
    //       </Typography>
    //     </Box>
    //   </Toolbar>
    // </AppBar>
  )
}

export default Topbar
